export function startInternalMenu(data) {
  data.button && data.button.addEventListener('click', (event) => {
    data.menu.classList.toggle('menu--show')
  }, false)
}
